export function registerServiceWorker(onReady: (reg: ServiceWorkerRegistration) => void) {
    if (!("serviceWorker" in navigator)) return;

    navigator.serviceWorker
        .register(`/service-worker.js`, {
            type: "module",
            updateViaCache: "none",
        })
        .then(reg => {
            onReady(reg);
        })
        .catch(error => {
            // eslint-disable-next-line no-console
            console.error("Service worker registration failed", error);
        });
}
